import type { FC, PropsWithChildren } from "react"

import styled from "styled-components"

export const FormFooterContainer = styled.div`
  background-color: var(--blue-form-footer);
  height: 75px;
  display: flex;
  justify-content: space-between;
  padding-right: 40px;
  padding-left: 40px;
  align-items: center;
  gap: 20px;
  a {
    text-decoration: none;
  }
`

export type FormFooterProps = PropsWithChildren<{
  children: React.ReactNode
  style?: React.CSSProperties
}>

const FormFooter: FC<FormFooterProps> = ({ children, style }) => {
  return (
    <FormFooterContainer className="form-footer" style={style}>
      {children}
    </FormFooterContainer>
  )
}

export default FormFooter
